import { Alert } from 'AWS-UI-Components-React';

export class ThresholdCrossedMessage extends React.Component {
  render() {
    return (
      <div className="awsui-util-t-c">
        <div className="awsui-util-pt-xs">
          <div className="awsui-util-pt-xs awsui-util-mb-xs">
            <Alert
              header="The UI might get slow because of the number of comparisons."
              onDismiss={this.props.onDismiss}
              visible={this.props.visible}
              dismissAriaLabel="Close alert"
              dismissible
            >
              <div>
                {' '}
                We have just loaded First Answer, Accuracy Benchmark and FA: Per Unit Variance (Net) columns by default.
                <br />
                You can <b> download </b> the data to see all the columns in an excel file
                <b> OR </b> You can add columns by clicking on the <b> gear icon </b>.
              </div>
            </Alert>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/threshold_crossed_message.js